import { Snackbar, Alert, AlertTitle, type SnackbarProps, type AlertColor } from '@mui/material';

interface ToastProps extends Omit<SnackbarProps, 'children'> {
  id?: string;
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  severity?: AlertColor;
}

const Toast = ({ variant = 'default', severity, title, description, onClose, ...props }: ToastProps) => {
  const resolvedSeverity: AlertColor = severity ?? (variant === 'destructive' ? 'error' : 'success');

  return (
    <Snackbar onClose={onClose} {...props}>
      <Alert
        onClose={onClose ? (event) => onClose(event, 'escapeKeyDown') : undefined}
        severity={resolvedSeverity}
        variant="filled"
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {description}
      </Alert>
    </Snackbar>
  );
};

export { Toast };
